(function () {
  if (window.Shopify && Shopify.designMode) {
    return;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  if (window.matchMedia("(max-width: 1023px)").matches) {
    return;
  }

  function initLenis() {
    if (typeof Lenis === "undefined") {
      return;
    }

    if (window.cromaLenis) {
      window.cromaLenis.destroy();
    }

    var lenis = new Lenis({
      duration: 1.15,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 0.85,
      touchMultiplier: 1,
      infinite: false
    });

    window.cromaLenis = lenis;

    if (typeof ScrollTrigger !== "undefined") {
      lenis.on("scroll", ScrollTrigger.update);
    }

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    document.documentElement.classList.add("lenis-enabled");

    document.addEventListener("shopify:section:load", function () {
      lenis.resize();

      if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.refresh();
      }
    });

    document.addEventListener("shopify:section:unload", function () {
      lenis.resize();

      if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.refresh();
      }
    });

    document.addEventListener("shopify:section:reorder", function () {
      lenis.resize();

      if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.refresh();
      }
    });

    document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function (anchor) {
      anchor.addEventListener("click", function (event) {
        var href = anchor.getAttribute("href");
        var target = document.querySelector(href);

        if (!target) {
          return;
        }

        event.preventDefault();

        lenis.scrollTo(target, {
          offset: 0
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLenis);
  } else {
    initLenis();
  }
})();